<template>
  <h1>Statement</h1>
</template>

<script setup lang="ts"></script>

<style lang="postcss" scoped></style>
